<template>
  <div class="title">
    基本信息
    <el-tag type="danger">必填</el-tag>
    <el-button
      v-show="!visible"
      type="primary"
      size="mini"
      plain
      style="margin-left: 50px"
      :disabled="!canEdit"
      :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
      @click="editFunc"
      >编辑</el-button
    >
  </div>
  <template v-if="!visible">
    <div v-if="modelValue.id" class="basic_list">
      <img :src="modelValue.photo" class="avatar" />
      <div class="content">
        <div class="name">
          {{ modelValue.name }}
        </div>
        <div class="base1">
          <span>{{ dicOptions.hr_sex.filter((d) => d.dictValue == modelValue.sex)[0]?.dictLabel }}</span>
          <span v-if="!isSpecific">|</span>
          <span v-if="!isSpecific">{{ modelValue.isFresh == 1 ? '应届' : '往届' }}</span>
          <span>|</span>
          <span><postcard />{{ modelValue.idNumber }}</span>
          <span><iphone />{{ modelValue.phoneNumber }}</span>
          <!-- <span>|</span>
          <span><message />{{ modelValue.email }}</span> -->
        </div>
        <div class="base3">
          <p>
            <span>{{ BASIC.birthday }}：</span>{{ formatDate('YYYY年MM月', new Date(modelValue.birthday)) }}
          </p>
          <p>
            <span>{{ BASIC.nation }}：</span>
            {{ dicOptions.hr_national.filter((d) => d.dictValue == modelValue.nation)[0]?.dictLabel }}
          </p>
          <p>
            <span>{{ BASIC.nativeplace }}：</span>
            {{ findAreaName(dicOptions.areaVos, modelValue.nativeplace) }}
          </p>
          <p>
            <span>{{ BASIC.nativeLocal }}：</span>
            {{ findAreaName(dicOptions.areaVos, modelValue.nativeLocal) }}
          </p>
          <p>
            <span>{{ BASIC.currentWork }}：</span>
            {{ modelValue.currentWork }}
          </p>
          <p v-if="modelValue.workDate">
            <span>{{ BASIC.workDate }}：</span>
            {{ formatDate('YYYY年MM月', new Date(modelValue.workDate)) }}
          </p>
          <p>
            <span>{{ BASIC.profession }}：</span>
            {{ modelValue.profession }}
          </p>
          <p v-if="modelValue.professionDate">
            <span>{{ BASIC.professionDate }}：</span>
            {{ formatDate('YYYY年MM月', new Date(modelValue.professionDate)) }}
          </p>
          <p>
            <span>{{ BASIC.political }}：</span>
            {{ dicOptions.hr_political.filter((d) => d.dictValue == modelValue.political)[0]?.dictLabel }}
          </p>
          <p v-if="modelValue.joinDate">
            <span>{{ BASIC.joinDate }}：</span>
            {{ formatDate('YYYY年MM月', new Date(modelValue.joinDate)) }}
          </p>
          <p v-if="modelValue.maritalStatus >= 0 && modelValue.maritalStatus !== null">
            <span>{{ BASIC.maritalStatus }}：</span>
            {{ dicOptions.hr_marry.filter((d) => d.dictValue == modelValue.maritalStatus)[0]?.dictLabel }}
          </p>
          <p v-if="modelValue.health >= 0 && modelValue.health !== null">
            <span>{{ BASIC.health }}：</span>
            {{ dicOptions.hr_health.filter((d) => d.dictValue == modelValue.health)[0]?.dictLabel }}
          </p>
          <p>
            <span>{{ BASIC.address }}：</span>
            {{ findAreaName(dicOptions.areaVos, modelValue.address) + ' ' + (modelValue.addressDetail || '') }}
          </p>
          <p v-if="!isSpecific">
            <span>{{ BASIC.adjustment }}：</span>
            {{ dicOptions.hr_adjustment.filter((d) => d.dictValue == modelValue.adjustment)[0]?.dictLabel }}
          </p>
          <!-- 档案地址太长放一行 -->
          <!-- <div>
            <span>{{ BASIC.archivesLocal }}：</span>
            {{ findAreaName(dicOptions.areaVos, modelValue.archivesLocal) + ' ' + (modelValue.archivesLocalDetail || '') }}
          </div> -->
        </div>
      </div>
    </div>
    <div v-else class="desc">介绍一下自己吧！</div>
  </template>
  <el-form v-show="visible" ref="formRef" :model="formData" :rules="rules" label-width="130px" style="position: relative">
    <div v-show="false">
      <el-form-item label="Id：" prop="id">
        <el-input v-model="formData.id" />
      </el-form-item>
    </div>
    <el-row>
      <el-col :span="22">
        <el-form-item label="上传照片" prop="photo">
          <el-upload
            class="avatar-uploader"
            action="/prod-api/recruitment/sso/uploadfile"
            :headers="{ Authorization: 'Bearer ' + getToken() }"
            name="uploadfile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="formData.photo" :src="formData.photo" class="avatar" />
            <avatar v-else class="avatar-uploader-icon" />
          </el-upload>
          <el-alert title="请上传近期一寸免冠登记照！" type="warning" :closable="false" style="height: 35px; width: 305px; top: 8px" show-icon />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.name + ':'" prop="name">
          <el-input v-model="formData.name" placeholder="请填写真实姓名" clearable maxlength="20" />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.idNumber + ':'" prop="idNumber">
          <el-input v-model="formData.idNumber" placeholder="请填写身份证号" maxlength="18" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.sex + ':'" prop="sex">
          <el-radio-group v-model="formData.sex" size="small">
            <el-radio-button v-for="item in dicOptions.hr_sex" :key="item.dictValue" :label="item.dictValue">
              {{ item.dictLabel }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.birthday + ':'" prop="birthday">
          <el-date-picker v-model="formData.birthday" disabled type="month" placeholder="根据身份证自动填入" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.nation + ':'" prop="nation">
          <el-select v-model="formData.nation" :placeholder="`请选择${BASIC.nation}`" filterable clearable style="width: 100%">
            <el-option v-for="item in dicOptions.hr_national" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.phoneNumber + ':'" prop="phoneNumber">
          <el-input v-model="formData.phoneNumber" :placeholder="`请填写${BASIC.phoneNumber}`" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.nativeplace + ':'" prop="nativeplace">
          <el-cascader
            v-model="formData.nativeplace"
            :options="dicOptions.areaVos"
            :props="{ emitPath: false, value: 'code', label: 'name' }"
            clearable
            filterable
            placeholder="请选择籍贯"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.nativeLocal + ':'" prop="nativeLocal">
          <el-cascader
            v-model="formData.nativeLocal"
            :options="dicOptions.areaVos"
            :props="{ emitPath: false, value: 'code', label: 'name' }"
            clearable
            filterable
            :placeholder="`请选择${BASIC.nativeLocal}`"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="11">
        <el-form-item :label="BASIC.email + ':'" prop="email">
          <el-input v-model="formData.email" placeholder="请填写电子邮箱" clearable />
        </el-form-item>
      </el-col> -->
      <el-col :span="11">
        <el-form-item :label="BASIC.currentWork + ':'" prop="currentWork">
          <el-input v-model="formData.currentWork" :placeholder="`请填写现${BASIC.currentWork}`" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.workDate + ':'" prop="workDate">
          <el-date-picker v-model="formData.workDate" type="month" placeholder="请选择首次参加工作时间" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.profession + ':'" prop="profession">
          <el-input v-model="formData.profession" :placeholder="`请填写${BASIC.profession}`" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="11" v-if="formData.profession !== '无'">
        <el-form-item :label="BASIC.professionDate + ':'" prop="professionDate">
          <el-date-picker
            v-model="formData.professionDate"
            type="month"
            :placeholder="'请选择' + BASIC.professionDate"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.health + ':'" prop="health">
          <el-select v-model="formData.health" placeholder="请选择健康状况" clearable style="width: 100%">
            <el-option v-for="item in dicOptions.hr_health" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.maritalStatus + ':'" prop="maritalStatus">
          <el-select v-model="formData.maritalStatus" placeholder="请选择婚姻状况" clearable style="width: 100%">
            <el-option v-for="item in dicOptions.hr_marry" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11" v-if="!isSpecific">
        <el-form-item :label="BASIC.isFresh + ':'" prop="isFresh">
          <el-radio-group v-model="formData.isFresh">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="11" v-if="!isSpecific">
        <el-form-item :label="BASIC.adjustment + ':'" prop="adjustment">
          <el-radio-group v-model="formData.adjustment">
            <el-radio
              v-for="item in dicOptions.hr_adjustment.sort((a, b) => b.dictValue - a.dictValue)"
              :key="item.dictValue"
              :label="item.dictValue"
            >
              {{ item.dictLabel }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="BASIC.political + ':'" prop="political">
          <el-select v-model="formData.political" placeholder="请选择政治面貌" clearable style="width: 100%">
            <el-option v-for="item in dicOptions.hr_political" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11" v-if="[0, 1].includes(formData.political)">
        <el-form-item :label="BASIC.joinDate + ':'" prop="joinDate">
          <el-date-picker v-model="formData.joinDate" type="month" :placeholder="`请选择${BASIC.joinDate}`" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row style="width: 100%">
      <el-col :span="11">
        <el-form-item :label="BASIC.address + ':'" prop="address">
          <el-cascader
            v-model="formData.address"
            :options="dicOptions.areaVos"
            :props="{ emitPath: false, value: 'code', label: 'name' }"
            clearable
            filterable
            placeholder="请选择家庭地址"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label-width="0" prop="addressDetail" style="margin-left: 10px">
          <el-input v-model="formData.addressDetail" :placeholder="`${BASIC.addressDetail}`" clearable maxlength="50" />
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row style="width: 100%">
      <el-col :span="11">
        <el-form-item :label="BASIC.archivesLocal + ':'" prop="archivesLocal">
          <el-cascader
            v-model="formData.archivesLocal"
            :options="dicOptions.areaVos"
            :props="{ emitPath: false, value: 'code', label: 'name' }"
            clearable
            filterable
            placeholder="请选择档案所在地"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label-width="0" prop="archivesLocalDetail" style="margin-left: 10px">
          <el-input v-model="formData.archivesLocalDetail" placeholder="具体地址" clearable maxlength="50" />
        </el-form-item>
      </el-col>
    </el-row> -->
    <el-form-item class="submit" label-width="0" v-show="visible">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="onReset">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { reactive, watch, toRefs, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { Avatar, Iphone, Message, Postcard } from '@element-plus/icons';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ApplicantApi from '../../service/api/applicant';
import { BASIC } from '../../utils/resume';
import { validateEmail, validatePhoneNumber, validateIdNumber, findAreaName } from '../../utils/operation';
import { formatDate } from '../../utils/tools';
import { getToken } from '../../service/cookie';

export default {
  name: 'Basic',
  components: { Avatar, Iphone, Message, Postcard },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    isSpecific: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      visible: false,
      formRef: null,
      formData: {},
      // rules: {
      //   photo: [{ required: true, message: BASIC.photo + '必填', trigger: 'change' }],
      //   name: [{ required: true, message: BASIC.name + '必填', trigger: 'change' }],
      //   idNumber: [
      //     { required: true, message: BASIC.idNumber + '必填', trigger: 'change' },
      //     { validator: validateIdNumber, trigger: 'blur' },
      //   ],
      //   sex: [{ required: true, message: BASIC.sex + '必填', trigger: 'change' }],
      //   isFresh: [{ required: true, message: BASIC.isFresh + '必填', trigger: 'change' }],
      //   // workDate: [{ required: true, message: BASIC.workDate + '必填', trigger: 'change' }],
      //   address: [{ required: true, message: BASIC.address + '必填', trigger: 'change' }],
      //   // birthday: [{ required: true, message: BASIC.birthday + '必填', trigger: 'change' }],
      //   nativeplace: [{ required: true, message: BASIC.nativeplace + '必填', trigger: 'change' }],
      //   nation: [{ required: true, message: BASIC.nation + '必填', trigger: 'change' }],
      //   political: [{ required: true, message: BASIC.political + '必填', trigger: 'change' }],
      //   joinDate: [{ required: true, message: BASIC.joinDate + '必填', trigger: 'change' }],
      //   nativeLocal: [{ required: true, message: BASIC.nativeLocal + '必填', trigger: 'change' }],
      //   adjustment: [{ required: true, message: BASIC.adjustment + '必填', trigger: 'change' }],
      //   profession: [{ required: true, message: BASIC.profession + '必填', trigger: 'change' }],
      //   professionDate: [{ required: true, message: BASIC.professionDate + '必填', trigger: 'change' }],
      //   currentWork: [{ required: true, message: BASIC.currentWork + '必填', trigger: 'change' }],
      //   maritalStatus: [{ required: true, message: BASIC.maritalStatus + '必填', trigger: 'change' }],
      //   health: [{ required: true, message: BASIC.health + '必填', trigger: 'change' }],
      //   phoneNumber: [
      //     { required: true, message: BASIC.phoneNumber + '必填', trigger: 'change' },
      //     { validator: validatePhoneNumber, trigger: 'blur' },
      //   ],
      //   // email: [
      //   //   { required: true, message: BASIC.email + '必填', trigger: 'change' },
      //   //   { validator: validateEmail, trigger: 'blur' },
      //   // ],
      // },
    });
    watch(
      () => props.modelValue,
      () => {
        state.formData = { ...props.modelValue };
      },
    );

    watch(
      () => state.formData.idNumber,
      (nVal) => {
        if (nVal.length == 15) {
          state.formData.birthday = '19' + nVal.substr(6, 6);
        } else if (nVal.length == 18) {
          state.formData.birthday = nVal.substr(6, 8).replace(/(.{4})(.{2})/, '$1-$2-');
        }
      },
    );

    const beforeAvatarUpload = (file) => {
      const formatIsOk = ['image/jpeg', 'image/png'].includes(file.type);
      const isLimit = file.size / 1024 / 1024 < 2;

      if (!isLimit) {
        ElMessage.error('头像大小不能超过2MB!');
      }
      if (!formatIsOk) {
        ElMessage.error('头像必须是JPG或PNG格式!');
      }
      return formatIsOk && isLimit;
    };
    const handleAvatarSuccess = (res) => {
      if (res.code === 200 && res.data && res.data.url) {
        state.formData.photo = res.data.url;
        state.formRef.validateField('photo');
      } else {
        ElMessage.error('上传失败，请稍后重试');
      }
    };

    const store = useStore();
    const editFunc = () => {
      state.visible = true;
      state.formData = {
        ...props.modelValue,
        email: props.modelValue.email || store.state.userInfo.email,
      };
    };

    const onSubmit = () => {
      state.formRef.validate(async (valid) => {
        if (valid) {
          const userInfo = store.state.userInfo;
          const formData = { ...state.formData, userId: userInfo.userId };
          Object.entries(formData).forEach(([key, value]) => {
            if (value instanceof Date) {
              formData[key] = formatDate('YYYY-MM-DD', value) || '';
            }
          });
          try {
            if (formData.id) {
              await ApplicantApi.updateResumeBasic(formData);
            } else {
              const res = await ApplicantApi.addResumeBasic(formData);
              store.commit('SET_USERINFO', { basicId: res.basicId });
            }
            ElMessage.success('保存成功');
            context.emit('callback');
            state.visible = false;
          } catch (e) {
            console.error(e);
          }
        } else {
          return false;
        }
      });
    };
    const onReset = () => {
      state.visible = false;
    };

    const dicOptions = computed(() => store.state.dicOptions);
    const rules = computed(() => {
      return {
        photo: [{ required: true, message: BASIC.photo + '必填', trigger: 'change' }],
        name: [{ required: true, message: BASIC.name + '必填', trigger: 'change' }],
        idNumber: [
          { required: true, message: BASIC.idNumber + '必填', trigger: 'change' },
          { validator: validateIdNumber, trigger: 'blur' },
        ],
        sex: [{ required: true, message: BASIC.sex + '必填', trigger: 'change' }],
        isFresh: [{ required: true, message: BASIC.isFresh + '必填', trigger: 'change' }],
        workDate: [{ required: props.isSpecific, message: BASIC.workDate + '必填', trigger: 'change' }],
        address: [{ required: true, message: BASIC.address + '必填', trigger: 'change' }],
        birthday: [{ required: true, message: BASIC.birthday + '必填', trigger: 'change' }],
        nativeplace: [{ required: true, message: BASIC.nativeplace + '必填', trigger: 'change' }],
        nation: [{ required: true, message: BASIC.nation + '必填', trigger: 'change' }],
        political: [{ required: true, message: BASIC.political + '必填', trigger: 'change' }],
        joinDate: [{ required: true, message: BASIC.joinDate + '必填', trigger: 'change' }],
        nativeLocal: [{ required: true, message: BASIC.nativeLocal + '必填', trigger: 'change' }],
        adjustment: [{ required: true, message: BASIC.adjustment + '必填', trigger: 'change' }],
        profession: [{ required: props.isSpecific, message: BASIC.profession + '必填', trigger: 'change' }],
        professionDate: [{ required: props.isSpecific, message: BASIC.professionDate + '必填', trigger: 'change' }],
        currentWork: [{ required: props.isSpecific, message: BASIC.currentWork + '必填', trigger: 'change' }],
        maritalStatus: [{ required: true, message: BASIC.maritalStatus + '必填', trigger: 'change' }],
        health: [{ required: true, message: BASIC.health + '必填', trigger: 'change' }],
        phoneNumber: [
          { required: true, message: BASIC.phoneNumber + '必填', trigger: 'change' },
          { validator: validatePhoneNumber, trigger: 'blur' },
        ],
        // email: [
        //   { required: true, message: BASIC.email + '必填', trigger: 'change' },
        //   { validator: validateEmail, trigger: 'blur' },
        // ],
      };
    });

    return {
      router: useRouter(),
      ...toRefs(state),
      beforeAvatarUpload,
      handleAvatarSuccess,
      editFunc,
      onSubmit,
      onReset,
      getToken,
      formatDate,
      BASIC,
      dicOptions,
      rules,
      findAreaName,
    };
  },
};
</script>

<style scoped lang="scss">
.avatar-uploader {
  line-height: 0;
  :deep(.el-upload) {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
}
.avatar-uploader-icon {
  color: #8c939d;
  padding: 12px;
  width: 85px;
  height: 127px;
  text-align: center;
}
.avatar {
  width: 85px;
  height: 119px;
  object-fit: cover;
  object-position: top;
}

.title {
  color: #000;
  font-size: 20px;
  padding: 20px;
  font-weight: 600;
  position: relative;
  ::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 24px;
  }
}
.basic_list {
  display: flex;
  padding-left: 20px;
  .content {
    flex: 1;
    color: #333;
    font-size: 16px;
    padding-left: 20px;
    svg {
      width: 20px;
      vertical-align: top;
      margin-right: 4px;
    }
    .name {
      line-height: 25px;
      margin-bottom: 10px;
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    .base1 {
      height: 20px;
      line-height: 20px;
      margin-bottom: 10px;
      span {
        margin-right: 10px;
      }
    }
    .base3 {
      p {
        width: 50%;
        display: inline-flex;
        margin-bottom: 10px;
      }
      div {
        display: flex;
        margin-bottom: 10px;
      }
      span {
        color: #999;
      }
    }
  }
}
.desc {
  padding-left: 30px;
  font-size: 14px;
  margin: 7px 0 20px;
  color: #606266;
}
.submit {
  margin-top: 30px;
  text-align: center;
}
</style>
